import classNames from 'classnames';
import { useMemo } from 'react';
import IconRenderer, { IconDefinition } from '../IconRenderer';
import styles from './styles/StatusBadge.module.scss';

export type StatusBadgeProps = {
  className?: string;
  icon?: IconDefinition<'orientation'>;
  variant: 'caution' | 'info' | 'inverse' | 'negative' | 'neutral' | 'positive';
  text: string;
  title?: string;
  onClick?: () => void;
  size: 'sm' | 'md';
  treatment: 'default' | 'minimal' | 'strong';
};

// https://www.figma.com/design/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?node-id=3559-61646&t=8N0pKlYEr2NhrNzg-4
const StatusBadge = ({ className, icon, variant, text, title, onClick, size, treatment }: StatusBadgeProps) => {
  const iconElement = useMemo(() => {
    if (treatment === 'minimal') {
      return <div className={styles.dot} />;
    }
    return icon ? <IconRenderer icon={icon} defaults={{ color: 'currentColor', size: 'xs' }} /> : null;
  }, [icon, treatment]);

  const content = useMemo(
    () => (
      <>
        {iconElement}
        <span className={styles.textContent} title={title}>
          {text}
        </span>
      </>
    ),
    [iconElement, title, text]
  );

  const classes = [styles.container, styles[size], styles[variant], styles[treatment], { [styles.minimal]: treatment === 'minimal' }, className];

  return onClick ? (
    <button className={classNames(styles.button, ...classes)} onClick={onClick}>
      {content}
    </button>
  ) : (
    <div className={classNames(...classes)}>{content}</div>
  );
};

export default StatusBadge;
